import shouldForwardProp from "@styled-system/should-forward-prop";
import { styled, EmotionComponent } from "../../styled";
import {
  space,
  layout,
  SpaceProps,
  LayoutProps,
  compose,
  OverrideNativeElementProps,
} from "../../utils/styleFn";

const styleProps = compose(space, layout);

type StyleProps = SpaceProps & LayoutProps;
export type PictureProps = OverrideNativeElementProps<StyleProps, "picture">;

export const Picture: EmotionComponent<PictureProps, {}> = styled("picture", {
  shouldForwardProp,
})`
  height: auto;
  ${styleProps}
`;

export default Picture;
